import { lazy } from "react";

// The dialogs hold the absence forms. Each loads on its first opening, not with the page that mounts the hook.
export const CreateAbsenceSidebar = lazy(() => import("~/modules/absence/components/AbsencesView/components/CreateAbsenceSidebar"));
export const DeleteAbsenceModal = lazy(() => import("~/modules/absence/components/AbsencesView/components/DeleteAbsenceModal"));
export const UpdateAbsenceSidebar = lazy(() => import("~/modules/absence/components/AbsencesView/components/UpdateAbsenceSidebar"));
